import React, { useContext, Fragment, isValidElement } from 'react';
import { Typography } from '@core-ui/typography';
import { PageDataContext } from '../../providers/page-data-provider';
import { useMobile } from '../../hooks/mobile.hook';
import { useBRRedesign } from '../../hooks/br-redesign.hook';
import copyblockStyles from './styles';

const Copyblock = (): JSX.Element => {
  const { copyblock } = useContext(PageDataContext);
  const isMobileStyle = useMobile() || useBRRedesign();

  return (
    <Fragment>
      {
        isValidElement(copyblock) &&
        <div className="copyblock" data-testid="copyblock">
          <Typography
            element="div"
            variant="body4"
            customStyles={copyblockStyles(isMobileStyle)}
          >
            {copyblock}
          </Typography>
        </div>
      }
    </Fragment>
  );
};

export default Copyblock;
